﻿import {InstallationId} from "@2d-front-monorepo/permits-business";
import {GlobalContext} from "../contexts/GlobalContext";

export default function getInstallationId(): InstallationId | undefined {
	return GlobalContext.tryGetData()?.installation?.id;
}
